import React, { useState, useEffect } from "react";
import { AppProvider, useAppContext } from "@/AppContext";
import { ReactFlowProvider } from "@xyflow/react";
import PageTop from "@/Pages/Project/PageTop";
import PageSeletor from "@/Pages/Project/Flow/Right/PageSeleltor";
import { useLocation, useParams } from "react-router-dom";
import materialsDB from '@/constants/materialsDB';
import { rebuildFormula } from '@/config/func';
import CalculateTask3DYCZPage from './calculateTask3DYCZPage';
import "./index.less";
import { getJob } from "@/services/common";
import userInfo from "@/Components/user";

const ComparativeAnalysis = () => {
  const { state, actions } = useAppContext();
  
  const params = useParams<{ k: string; f: string }>();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const taskIds = query.get('taskIds')?.split(',') || [];

  // ===================== 核心：存储多个任务数据 =====================
  const [taskDataList, setTaskDataList] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  // 批量获取所有选中任务的数据
  useEffect(() => {
    if (!taskIds.length) return;

    const fetchAllJobs = async () => {
      setLoading(true);
      const results: any[] = [];

      for (const id of taskIds) {
        try {
          const res = await getJob(Number(id), userInfo.access_token);
          if (res.status === 200) {
            const data = {
              taskId: id,
              name: res.data.name,
              inputs: JSON.parse(res.data.input),
              output: JSON.parse(res.data.output),
            };
            results.push(data);
          }
        } catch (err) {
          console.error(`任务 ${id} 获取失败`, err);
        }
      }

      setTaskDataList(results);
      setLoading(false);
    };

    fetchAllJobs();
  }, []);

  // 转换物料（只需要用第一个任务的结构生成侧边栏）
  const transformMaterials = (rawMaterials: any[]) => {
    return rawMaterials.map((material, index) => {
      const m: any = materialsDB.find((item) => item.cas === material.cas);
      return {
        cas: material.cas,
        Molecular_formula: rebuildFormula(m.Molecular_formula),
        Name_ZH: m.Name_ZH,
        MW: m.MW,
        index: index,
        molar_frac: material.molar_frac,
      };
    });
  };

  // 取第一个任务的 input 生成侧边栏菜单（逻辑不变）
  const firstTask = taskDataList[0];
  const transInput = firstTask ? {
    materials: transformMaterials(
      firstTask.inputs?.streams?.filter(
        (item: any) => item?.materials.length > 0
      )[0]?.materials || []
    )
  } : {};

  // ==================== 新增：为每个任务生成对应的 transInput ====================
  const transInputs = taskDataList.map(task => {
    return task.inputs ? {
      materials: transformMaterials(
        task.inputs?.streams?.filter(
          (item: any) => item?.materials.length > 0
        )[0]?.materials || []
      )
    } : {};
  });

  return (
    <ReactFlowProvider>
      {!loading && taskDataList.length > 0 ? (
        <>
          <PageTop
            mainContent={
              <div className="settingSelectorArea">
                <PageSeletor />
              </div>
            }
          />
          <div className="mainContent">
            <div className="mainTask" style={{ width: "95%" }}>
              <div className="tabContainer">
                <div className="tabTitle">计算任务对比分析：</div>
              </div>

              <div className="tabContent">
                {/* ===================== 传入：所有任务数据 ===================== */}
                <CalculateTask3DYCZPage
                  input={firstTask.inputs}          // 左侧菜单用
                  transInput={transInput}            // 左侧菜单用（第一个任务，侧边栏用）
                  transInputs={transInputs}          // 每个任务对应的 input 数据
                  taskDataList={taskDataList}        // 所有任务（对比用）
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <div>加载中...</div>
      )}
    </ReactFlowProvider>
  );
};

export default ComparativeAnalysis;